class PaymentController extends BaseController
	@register angular.module 'App.Module.Controller'
	@inject '$scope', 'API_ENDPOINT', 'CredentialsManager', 'BillingInvoiceRepository'

	initialize: ->
		@$scope.page = 0
		@BillingInvoiceRepository.setPageSize(50)
		@pageSize = @BillingInvoiceRepository.getPageSize()
		@searching = false

		@$scope.access_token = @CredentialsManager.getResourceToken()
		@$scope.pdf_url = @API_ENDPOINT + '/render/pdf/billing_invoices/'
		@$scope.payments = @search()

	search: (keep_pagination) ->
		@searching = true

		if !angular.isDefined(keep_pagination) || keep_pagination is false
			@$scope.page = 0

		query = do @BillingInvoiceRepository.createQuery
		query.with 'billing_invoice_line_items'
		query.sortBy 'create_time', 'DESC'
		query.setPagination @$scope.page * @pageSize, @pageSize

		_this = @
		@BillingInvoiceRepository.findByQuery query
		.then (response) ->
			_this.$scope.payments = response.data
			_this.setPaymentsCount query
			_this.searching = false
			return

		return

	setPaymentsCount: (query) ->
		_this = @
		@BillingInvoiceRepository.count query
		.then (response) ->
			_this.$scope.paymentsCount = response.data.count
			_this.setTablePageInfo()
		return

	nextPage: ->
		if !@searching
			@$scope.page++
			@search true

	prevPage: ->
		if !@searching
			@$scope.page--
			@search true

	showNextPage: ->
		return @$scope.paymentsCount > (@$scope.page + 1) * @pageSize

	showPrevPage: ->
		return @$scope.page > 0

	setTablePageInfo: ->
		if @$scope.payments.length > 0
			@$scope.tablePageInfo =
				from: @$scope.page * @pageSize + 1
				to: @$scope.page * @pageSize + @$scope.payments.length
				of: @$scope.paymentsCount
